import { ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import type { DuplicateGroup } from './toDuplicateGroups';

export const findDuplicates = actionCreator(
  '[documentArchiveDuplicates] FIND_DUPLICATES'
);

export const duplicatesLoaded = actionCreator<DuplicateGroup[]>(
  '[documentArchiveDuplicates] DUPLICATES_LOADED'
);

export const duplicatesLoadFailed = actionCreator(
  '[documentArchiveDuplicates] DUPLICATES_LOAD_FAILED'
);

export const noDuplicatesFound = actionCreator(
  '[documentArchiveDuplicates] NO_DUPLICATES_FOUND'
);

export const toggleDuplicateSelected = actionCreator<ArdoqId>(
  '[documentArchiveDuplicates] TOGGLE_DUPLICATE_SELECTED'
);

export const closeDuplicatesModal = actionCreator(
  '[documentArchiveDuplicates] CLOSE_DUPLICATES_MODAL'
);
